export default __webpack_public_path__ + "navigation-overview-setup-ib-segue-1200-639959b06ea729407696857858dc3c4f.png";